import React from "react";
import Counter from "./Counter";

function OverallReportCard({ data }) {
  return (
    <div className="w-[270px] h-[290px] hover:shadow-lg transition-all rounded-tr-[4rem] rounded-bl-[4rem] rounded-tl-xl rounded-br-xl  relative before:content-[''] before:inline-block before:w-full before:h-full before:bg-d-bg before:absolute before:-top-5 before:-left-5 before:rounded-tl-xl before:rounded-br-xl before:rounded-tr-[4rem] before:rounded-bl-[4rem] before:shadow-inner ">
      <div className="bg-white grid place-items-center text-d-bg-text h-full w-full rounded-tr-[4rem] rounded-bl-[4rem] rounded-tl-xl rounded-br-xl relative before:content-[''] before:inline-block before:w-[90%] before:h-[90%] before:border-2 before:border-d-bg before:absolute  before:rounded-tl-xl before:rounded-br-xl before:rounded-tr-[4rem] before:rounded-bl-[4rem] ">
        <div className="pt-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width={60}
            height={40}
            className="fill-d-bg-text  "
          >
            {data.path}
          </svg>
        </div>
        <h1 className="text-d-bg-text font-semibold text-xl p ">
          {data.title}
        </h1>
        <Counter
          initialValue={data.count}
          duration={4000}
          className="text-d-bg-text"
        />

        <h1 className="text-d-bg-text font-semibold text-3xl ">
          {data.titletwo}
        </h1>
        <div className="text-d-bg-text  text-3xl pb-5 ">
          <Counter initialValue={data.counttwo} duration={4000} />
        </div>
      </div>
    </div>
  );
}

export default OverallReportCard;
